import React, { useEffect, useState, } from 'react';
import BottomSheetMf, { BottomSheetAnimation, } from '../bottomSheetMF/bottomSheetMf';
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, FetchPortfolioModalType, IconSizeTokens, IconTokens, SizeTypeTokens, TextAlignTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import { TouchableOpacity, View, } from 'react-native';
import { Icon } from '../icon/Icon';
import { Space } from '../space/Space';
import { Typography } from '../typography/Typography';
import ThemeProvider from '@voltmoney/theme';
import { Button } from '../button/Button';
import ProgressBarComponent from '../progressBar';
const FetchPortfolioModals = ({ height, title, subtitle, primaryCtaTitle, tertiaryCTATitle, primaryCtaAction, tertiaryCTAAction, visible = false, type = FetchPortfolioModalType.IMMEDIATE, loadingTime, onModalClose, loaderText, onModalCloseAction, errorModalBgColor, triggerAction, }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const [_show, setShowModal] = useState(false);
    const [_errorModalBgColor, setErrorModalBgColor,] = useState(undefined);
    useEffect(() => {
        if (title === null ||
            title === undefined ||
            title === 'null') {
            setShowModal(false);
        }
        else {
            setShowModal(visible);
        }
    }, [visible, title]);
    useEffect(() => {
        setErrorModalBgColor(errorModalBgColor);
    }, [errorModalBgColor]);
    return (React.createElement(BottomSheetMf, { modalVisible: _show, onModalClose: () => {
            setShowModal(false);
            onModalClose && onModalClose();
        }, animationType: BottomSheetAnimation.SLIDE, onModalOpen: () => setShowModal(true), backgroundColor: _errorModalBgColor, showClose: type !== FetchPortfolioModalType.LOADER, onClosePress: () => {
            onModalCloseAction &&
                triggerAction(onModalCloseAction);
        } },
        React.createElement(View, { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
            } },
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_WARNING_DLS, size: IconSizeTokens.XXXXXXXL })),
            title && title !== null && title !== 'null' && (React.createElement(React.Fragment, null,
                React.createElement(Space, { size: SizeTypeTokens.XL }),
                React.createElement(Typography, { label: title, typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }))),
            type !== FetchPortfolioModalType.LOADER &&
                subtitle &&
                subtitle !== null &&
                subtitle !== 'null' && (React.createElement(React.Fragment, null,
                React.createElement(Space, { size: SizeTypeTokens.XXXL }),
                React.createElement(View, { style: {
                        width: '100%',
                        padding: 8,
                        backgroundColor: colorMapping[ColorTokens.Warning_25],
                        borderRadius: 8,
                    } },
                    React.createElement(Typography, { label: subtitle, typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center })))),
            type !== FetchPortfolioModalType.LOADER &&
                primaryCtaAction && (React.createElement(React.Fragment, null,
                React.createElement(Space, { size: SizeTypeTokens.XXXL }),
                React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, label: primaryCtaTitle
                        ? primaryCtaTitle
                        : 'Test', onPress: async () => {
                        primaryCtaAction &&
                            (await triggerAction(primaryCtaAction));
                    } }))),
            type !== FetchPortfolioModalType.LOADER &&
                tertiaryCTAAction && (React.createElement(View, { style: {
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                } },
                React.createElement(Space, { size: SizeTypeTokens.XXXL }),
                React.createElement(TouchableOpacity, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                    }, onPress: async () => {
                        setShowModal(false);
                        tertiaryCTAAction &&
                            (await triggerAction(tertiaryCTAAction));
                    } },
                    React.createElement(Typography, { label: 'Need help? ', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }),
                    React.createElement(Typography, { label: tertiaryCTATitle
                            ? tertiaryCTATitle
                            : 'Test', typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Primary_100 })))),
            type === FetchPortfolioModalType.LOADER && (React.createElement(React.Fragment, null,
                React.createElement(Space, { size: SizeTypeTokens.XXXL }),
                loaderText && (React.createElement(View, { style: {
                        paddingBottom: 8,
                    } },
                    React.createElement(Typography, { label: loaderText, typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }))),
                React.createElement(ProgressBarComponent, { color: colorMapping[ColorTokens.Primary_100], unfilledColor: colorMapping[ColorTokens.Primary_20], loadingTime: loadingTime }))))));
};
export default FetchPortfolioModals;
